import { QueryClientProvider } from '@tanstack/react-query';
import { memo, ReactNode } from 'react';
import { queryClient } from './query-client';
import ApiClientsProvider from './ApiClientsProvider';

type Props = {
  children: ReactNode;
  getToken?: () => Promise<string | undefined>;
  legacyApiBaseUrl?: string;
  gatewayApiBaseUrl?: string;
  marketApiBaseUrl?: string;
  companyApiBaseUrl?: string;
  cloudApiBaseUrl?: string;
  toolsApiBaseUrl?: string;
};

const Provider = ({
  children,
  getToken,
  legacyApiBaseUrl,
  gatewayApiBaseUrl,
  marketApiBaseUrl,
  companyApiBaseUrl,
  cloudApiBaseUrl,
  toolsApiBaseUrl,
}: Props) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ApiClientsProvider
        legacyApiBaseUrl={legacyApiBaseUrl}
        gatewayApiBaseUrl={gatewayApiBaseUrl}
        marketApiBaseUrl={marketApiBaseUrl}
        companyApiBaseUrl={companyApiBaseUrl}
        cloudApiBaseUrl={cloudApiBaseUrl}
        toolsApiBaseUrl={toolsApiBaseUrl}
        getToken={getToken}
      >
        {children}
      </ApiClientsProvider>
    </QueryClientProvider>
  );
};

export default memo(Provider);
